import { ProductCardProduct } from "@/features/product/ProductCard";
import { Money, $ } from "@/helpers/Money";

export interface GiftProduct extends ProductCardProduct {
  variantId: number;
}

export const giftWithPurchase = {
  active: false,
  get optionsActive(): boolean {
    return this.active;
  },
  products: [
    {
      featuredImage: {
        src: "//www.dropps.com/cdn/shop/products/Dropps_Fabric-Softener_Lavender-Eucalyptus_6CT.jpg?v=1664293289",
        height: 80,
        width: 80,
      },
      title: "Fabric Softener Sample Pods, Lavender Eucalyptus",
      size: "6ct Sample",
      price: Money.zero,
      compareAtPrice: $`5`,
      variantId: 39837880451171,
    },
    // {
    //   featuredImage: {
    //     src: "//cdn.shopify.com/s/files/1/0268/4219/products/dropps_pdpmainimage_6ctbox_dishwasherlemon.png?v=1605581517",
    //     width: 80,
    //     height: 80,
    //   },
    //   title: "Dishwasher Detergent Pods, Lemon",
    //   size: "6 Count",
    //   price: Money.zero,
    //   compareAtPrice: $`5`,
    //   variantId: 40045483851875,
    // },
    // {
    //   featuredImage: {
    //     src: "//cdn.shopify.com/s/files/1/0268/4219/products/dropps_pdpmainimage_6ctbox_laundrylavendereucalyptus.jpg?v=1670856416",
    //     height: 80,
    //     width: 80,
    //   },
    //   title: "Stain & Odor Laundry Detergent Pods, Lavender Eucalyptus",
    //   size: "6 Count",
    //   price: Money.zero,
    //   compareAtPrice: $`5`,
    //   variantId: 40045459538019,
    // },
    // {
    //   featuredImage: {
    //     src: "//cdn.shopify.com/s/files/1/0268/4219/products/dropps_pdpmainimage_6ctbox_laundryactivewashroseenergy.png?v=1652384748",
    //     height: 80,
    //     width: 80,
    //   },
    //   title: "Active Wash Laundry Detergent Pods, Rose Energy",
    //   size: "6 Count",
    //   price: Money.zero,
    //   compareAtPrice: $`5`,
    //   variantId: 40045483491427,
    // },
  ] satisfies GiftProduct[],
};
